import React, { useEffect, useState } from "react";
import { consumeCognitoPkce } from "@/utils/cognitoAuth";
import LoadingScreen from "@/components/LoadingScreen";

const CognitoCallback = () => {
  const [error, setError] = useState("");

  useEffect(() => {
    const complete = async () => {
      const params = new URLSearchParams(window.location.search);
      const providerError = params.get("error_description") || params.get("error");
      if (providerError) throw new Error(providerError);
      const code = params.get("code");
      const state = params.get("state");
      if (!code || !state) throw new Error("AWS email sign-in did not return a valid code");
      const saved = consumeCognitoPkce(state);
      const response = await fetch("/api/auth/social/cognito/exchange", {
        method: "POST",
        credentials: "include",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          code,
          code_verifier: saved.verifier,
          redirect_uri: saved.redirect_uri,
        }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data.session_token) {
        throw new Error(data.detail || "AWS email sign-in could not be completed");
      }
      try { window.localStorage.setItem("session_token", data.session_token); } catch (storageError) {}
      window.location.replace(`/events#session_token=${encodeURIComponent(data.session_token)}`);
    };
    complete().catch((reason) => setError(String(reason?.message || reason)));
  }, []);

  if (!error) return <LoadingScreen />;
  return (
    <main className="flex min-h-screen items-center justify-center bg-[#080b12] p-6 text-white">
      <section className="w-full max-w-md rounded-2xl border border-red-400/30 bg-red-500/10 p-6 text-center">
        <h1 className="text-xl font-bold">Email sign-in could not be completed</h1>
        <p className="mt-3 text-sm text-red-100">{error}</p>
        <a className="mt-6 inline-flex rounded-xl bg-blue-600 px-5 py-3 font-bold" href="/">Try another sign-in method</a>
      </section>
    </main>
  );
};

export default CognitoCallback;
